import clsx from 'clsx'
import React, { useRef } from 'react'
import { withAutoBlur } from '../../utils/misc'
import useOpacityToggle from '@hooks/useOpacityToggle'
import { ChangeOpacityComponents } from 'game-ui-types'

interface NavButtonProps {
    id: string
    icon: string
    showBorder: boolean
    classNames?: string
    onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void
    disabled?: boolean
    componentName?: ChangeOpacityComponents
}

const NavButton: React.FC<NavButtonProps> = ({
    id,
    icon,
    showBorder = false,
    classNames,
    onClick,
    disabled = false,
    componentName,
}) => {
    const navButtonComponent = useRef<HTMLButtonElement | null>(null)

    if (componentName) useOpacityToggle(componentName, navButtonComponent)

    return (
        <button
            id={id}
            ref={navButtonComponent}
            onClick={!disabled ? withAutoBlur(onClick) : undefined}
            className={clsx(
                'outline-none flex items-center pointer-events-auto justify-center rounded-full',
                classNames,
                showBorder && 'border-[2px]'
            )}
            style={{
                width: '76px',
                height: '76px',
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
            }}
        >
            <img src={icon} alt="Navigation Button" className="w-full h-full object-contain" />
        </button>
    )
}

export default NavButton
